import { Button } from "@mwi/ui";

const ErrorMessageWithRetry = ({
  onRetry,
  title,
  message,
  "data-test-id": dataTestId,
}: {
  onRetry: any;
  title: string;
  message: string;
  "data-test-id"?: string;
}): JSX.Element => {
  return (
    <div
      className="flex flex-col flex-grow items-center justify-center"
      data-test-id={dataTestId}
    >
      <h3 data-test-id={`${dataTestId}_Title`}>{title}</h3>
      <p data-test-id={`${dataTestId}_Message`}>{message}</p>
      {onRetry && (
        <Button
          className="mt-6"
          variant="outlined"
          size="small"
          onClick={onRetry}
          data-test-id={`${dataTestId}_RetryButton`}
        >
          Retry
        </Button>
      )}
    </div>
  );
};

export default ErrorMessageWithRetry;
